import React from "react";
import PropTypes from "prop-types";
import Fieldset from "../../common/Fieldset";
import TextAreaInput from "../../common/TextAreaInput";
import TextInput from "../../common/TextInput";
import Row from "../../common/Row";
import DownloadUploadFiles from "../../common/DownloadUploadFiles";
import Tooltip from "../../common/Tooltip";
import RadioButtonText from "../../common/RadioButtonText";
import FieldsetSubHeader from "../../common/FieldsetSubHeader";
import * as types from "../../../constants/ComponentConstants";
import * as domainConstants from "../../../constants/DomainConstants";

const IntegraleToegankelijkheidForm = (props) => {
	const {
		beoordelingscriteria,
		disabled,
		errors,
		onChange,
		documenten,
		onCheckboxChange,
		onDropFiles,
		onDeleteFile,
		color,
		fileTypes,
		fileSessionStarted,
		validationMessageType
	} = props;

	const jaNee = [{ value: "true", label: 'Ja' }, { value: "false", label: 'Nee' }];

	function getFilesForDossierComponent(component) {
		if (documenten && documenten.find(x => x.name === component)) {
			return documenten.find(x => x.name === component).files;
		} else return [];
	}

	function hasFilesForDossierComponent(component) {
		if (documenten && documenten.find(x => x.name === component)) {
			const files = documenten.find(x => x.name === component).files;
			if (files) {
				return files.length > 0 ? true : false;
			}
		}
		return false;
	}

	function mapDropFiles(component) {
		return function (files) {
			onDropFiles(component, files);
		};
	}

	function mapDeleteFile(component) {
		return function (fileName) {
			onDeleteFile(component, fileName);
		};
	}

	const TOEGANKELIJKHEID_TOOLTIP1 = "Omschrijf welke acties bijdragen tot het geven van gelijke kansen en een evenwaardige participatie. Geef aan wat er reeds aanwezig is en/ of je bijkomende inspanningen zal doen. Enkel een beleid inzake tarieven is onvoldoende. Als bijlage kan je een brochure of beleidsdocument toevoegen.";
	const TOEGANKELIJKHEID_TOOLTIP2 = "Toegankelijkheid is meer dan ‘een rolstoel’ en ‘brede deuren’ alleen. Sinds enige tijd streven wij in Vlaanderen naar een geïntegreerde en proactieve visie met oog voor het ‘Ontwerpen voor iedereen’. Indien er een bijlage wordt toegevoegd moet er in de omschrijving een duidelijke verwijzing zijn naar de bijlage.";
	const TOEGANKELIJKHEID_TOOLTIP3 = !beoordelingscriteria.isRenovatie ? "Geef aan hoe en waarom deze aanpak een antwoord is op de kwaliteit die Sport Vlaanderen i.s.m. Inter, Expertisecentrum toegankelijkheid en Universal Design wenst te bereiken. Enkel wettelijke bepalingen zijn onvoldoende. Geef in de bijlagen of omschrijving duidelijk weer welke status deze documenten hebben."
		: "Geef een omschrijving van de werken die je zal doen en welke toegankelijkheidsoptimalisatie je hiermee zal realiseren (binnen of buiten deze aanvraag). Geef aan hoe en waarom deze aanpak een antwoord is op de kwaliteit die Sport Vlaanderen i.s.m. Inter, Expertisecentrum toegankelijkheid en Universal Design wenst te bereiken. Enkel wettelijke bepalingen zijn onvoldoende. Geef in de bijlagen of omschrijving duidelijk weer welke status deze documenten hebben.";
	const titleIntegraleToegankelijkHeid = !beoordelingscriteria.isRenovatie ? "Op welke wijze is de integrale toegankelijkheid van de infrastructuur en zijn omgeving gegarandeerd."
		: "Op welke wijze is de integrale toegankelijkheid van de infrastructuur en zijn omgeving gegarandeerd of zal je deze optimaliseren.";
	const MULTIMODALE_ONTSLUITING_TOOLTIP = "Vlaanderen kent een grote verkeersdruk. Daarom is het belangrijk om bij het ontwerpen van infrastructuur ook in te zetten op alternatieve vervoerswijzen: het openbaar vervoer, de fiets, ... Het gaat dan niet alleen om de bereikbaarheid van de site, maar ook om infrastructurele maatregelen zoals het voorzien van voldoende en kwalitatieve fietsenstallingen e.d... Toon aan op welke manier je hiermee rekening gehouden hebt.";


	return (
		<Fieldset title="Integrale toegankelijkheid">
			<Row>
				<FieldsetSubHeader>
					Op welke wijze streef je naar een inclusief aanbod voor bezoekers waaronder vb. kansarmen, jonge gezinnen, sportclubs, allochtonen en in het bijzonder personen met een handicap en ouderen.
					<Tooltip
						text={TOEGANKELIJKHEID_TOOLTIP1}
						tooltipType={types.TOOLTIP_INFO}
						windowWidth={40} />
				</FieldsetSubHeader>
				<Row>
					&nbsp;
					<TextAreaInput
						name="inclusiefAanbod"
						label="Inclusief aanbod"
						value={beoordelingscriteria.inclusiefAanbod}
						onChange={onChange}
						height={4}
						disabled={disabled}
						validationMessage={errors ? errors.inclusiefAanbod : ''}
						validationMessageType={validationMessageType}
						maxLength={2000} />
				</Row>
				<Row>
					<DownloadUploadFiles
						dossierId={beoordelingscriteria.dossierId}
						title="Bewijsstukken inclusief aanbod"
						tooltip="Bv. een brochure of beleidsdocument"
						tooltipType={types.TOOLTIP_INFO}
						tooltipIconColor={types.COLOR_WHITE}
						center
						disabled={disabled}
						color={color}
						tab={domainConstants.DocumentTab.Criteria}
						component={domainConstants.ComponentName.BewijsstukkenAanbod}
						onDelete={mapDeleteFile(domainConstants.ComponentName.BewijsstukkenAanbod)}
						onDrop={mapDropFiles(domainConstants.ComponentName.BewijsstukkenAanbod)}
						files={getFilesForDossierComponent(domainConstants.ComponentName.BewijsstukkenAanbod)}
						validationMessage={errors ? errors.ulBewijsstukkenAanbod : ''}
						validationMessageType={validationMessageType}
						fileTypes={fileTypes.BewijsstukkenAanbod}
						tooltipWindowWidth={20}
						fileSessionStarted={fileSessionStarted} />
				</Row>
				&nbsp;
						<FieldsetSubHeader>
					Omschrijf op welke wijze je het thema toegankelijkheid in functie van de visie 'Ontwerpen voor iedereen' benadert en laat deel uitmaken van bv. de toekomstige vernieuwing, de dienstverlening of het (bouw)dossier.
					<Tooltip
						text={TOEGANKELIJKHEID_TOOLTIP2}
						tooltipType={types.TOOLTIP_INFO}
						windowWidth={30} />
				</FieldsetSubHeader>
				<Row>
					&nbsp;
					<TextAreaInput
						name="ontwerpenVoorIedereen"
						label="Ontwerpen voor iedereen"
						value={beoordelingscriteria.ontwerpenVoorIedereen}
						onChange={onChange}
						height={4}
						disabled={disabled}
						validationMessage={errors ? errors.ontwerpenVoorIedereen : ''}
						validationMessageType={validationMessageType}
						maxLength={2000} />
				</Row>
				<Row>

					<DownloadUploadFiles
						dossierId={beoordelingscriteria.dossierId}
						title="Bewijsstukken 'Ontwerpen voor iedereen'"
						center
						disabled={disabled}
						color={color}
						tab={domainConstants.DocumentTab.Criteria}
						component={domainConstants.ComponentName.BewijsstukkenOntwerpenVoorIedereen}
						onDelete={mapDeleteFile(domainConstants.ComponentName.BewijsstukkenOntwerpenVoorIedereen)}
						onDrop={mapDropFiles(domainConstants.ComponentName.BewijsstukkenOntwerpenVoorIedereen)}
						files={getFilesForDossierComponent(domainConstants.ComponentName.BewijsstukkenOntwerpenVoorIedereen)}
						validationMessage={errors ? errors.ulBewijsstukkenOntwerpen : ''}
						validationMessageType={validationMessageType}
						fileTypes={fileTypes.BewijsstukkenOntwerpenVoorIedereen}
						fileSessionStarted={fileSessionStarted} />
				</Row>
				&nbsp;
						<FieldsetSubHeader>
					{titleIntegraleToegankelijkHeid}
					<Tooltip
						text={TOEGANKELIJKHEID_TOOLTIP3}
						tooltipType={types.TOOLTIP_INFO}
						windowWidth={35}
						windowAlignRight={false} />
				</FieldsetSubHeader>
				<Row>
					&nbsp;
					<TextAreaInput
						name="garantieIntegraleToegankelijkheid"
						label="Garantie integrale toegankelijkheid"
						value={beoordelingscriteria.garantieIntegraleToegankelijkheid}
						onChange={onChange}
						height={4}
						disabled={disabled}
						validationMessage={errors ? errors.garantieIntegraleToegankelijkheid : ''}
						maxLength={2000}
						validationMessageType={validationMessageType} />
				</Row>
				<Row>
					<DownloadUploadFiles
						dossierId={beoordelingscriteria.dossierId}
						title="Bewijsstukken integrale toegankelijkheid"
						tooltip="Voeg in bijlage verduidelijkende documenten toe zoals bijvoorbeeld plannen met specifieke toegankelijkheidsinformatie (andere dan hierboven toegevoegde plannen), een toelichtingsnota toegankelijkheid, een referentie van een toegankelijkheidsonderzoek, … Geef ook duidelijk aan welke status deze documenten hebben."
						tooltipIconColor={types.COLOR_WHITE}
						tooltipWindowWidth={30}
						center
						disabled={disabled}
						color={color}
						tab={domainConstants.DocumentTab.Criteria}
						component={domainConstants.ComponentName.BewijsstukkenToegankelijkheid}
						onDelete={mapDeleteFile(domainConstants.ComponentName.BewijsstukkenToegankelijkheid)}
						onDrop={mapDropFiles(domainConstants.ComponentName.BewijsstukkenToegankelijkheid)}
						files={getFilesForDossierComponent(domainConstants.ComponentName.BewijsstukkenToegankelijkheid)}
						validationMessage={errors ? errors.ulBewijsstukkenToegankelijkheid : ''}
						fileTypes={fileTypes.BewijsstukkenToegankelijkheid}
						fileSessionStarted={fileSessionStarted}
						validationMessageType={validationMessageType} />
				</Row>
				&nbsp;
				<Row>
					<FieldsetSubHeader>Heb je een lopende samenwerking of convenant met Inter, het Expertisecentrum voor toegankelijkheid en Universal Design?</FieldsetSubHeader>
					<RadioButtonText
						label=""
						name="lopendeSamenwerkingMetInter"
						value={beoordelingscriteria.lopendeSamenwerkingMetInter || hasFilesForDossierComponent(domainConstants.ComponentName.UittrekselSamenwerkingsbeslissing)}
						onChange={onChange}
						disabled={disabled}
						items={jaNee}
						horizontal
						locked={hasFilesForDossierComponent(domainConstants.ComponentName.UittrekselSamenwerkingsbeslissing)}
						validationMessage={errors ? errors.lopendeSamenwerkingMetInter : ''}
						validationMessageType={validationMessageType}
					/>

					{beoordelingscriteria.lopendeSamenwerkingMetInter == true || beoordelingscriteria.lopendeSamenwerkingMetInter === "true" || hasFilesForDossierComponent(domainConstants.ComponentName.UittrekselSamenwerkingsbeslissing) ?
						<Row>
							<FieldsetSubHeader>Is er een goedkeuring om de dienstverlening van Inter voor dit project in te zetten of loopt er voor dit project al een begeleiding?</FieldsetSubHeader>
							<RadioButtonText
								label=""
								name="goedkeuringDienstverleningInter"
								value={beoordelingscriteria.goedkeuringDienstverleningInter}
								onChange={onChange}
								disabled={disabled}
								items={jaNee}
								horizontal
								validationMessageType={validationMessageType}
								validationMessage={errors ? errors.goedkeuringDienstverleningInter : ''}
							/>
							{beoordelingscriteria.goedkeuringDienstverleningInter == true || beoordelingscriteria.goedkeuringDienstverleningInter === "true" ?
								<Row>
									<TextInput
										name="dossierNummerInter"
										label="Dossiernummer"
										value={beoordelingscriteria.dossierNummerInter}
										onChange={onChange}
										disabled={disabled}
										size={5}
										validationMessage={errors ? errors.dossierNummerInter : ''}
										maxLength={100}
										validationMessageType={validationMessageType} />
								</Row>
								: ""}
							<Row>
								<DownloadUploadFiles
									dossierId={beoordelingscriteria.dossierId}
									title="Uittreksel samenwerkingsbeslissing"
									center
									disabled={disabled}
									color={color}
									tab={domainConstants.DocumentTab.Criteria}
									component={domainConstants.ComponentName.UittrekselSamenwerkingsbeslissing}
									onDelete={mapDeleteFile(domainConstants.ComponentName.UittrekselSamenwerkingsbeslissing)}
									onDrop={mapDropFiles(domainConstants.ComponentName.UittrekselSamenwerkingsbeslissing)}
									files={getFilesForDossierComponent(domainConstants.ComponentName.UittrekselSamenwerkingsbeslissing)}
									fileTypes={fileTypes.UittrekselSamenwerkingsbeslissing}
									validationMessage={errors ? errors.ulUittrekselSamenwerkingsbeslissing : ''}
									fileSessionStarted={fileSessionStarted}
									validationMessageType={validationMessageType} />
							</Row>
						</Row>
						: ""}
				</Row>
				&nbsp;
				<Row>
					<FieldsetSubHeader>Toon aan in welke mate de site bereikbaar is (“multimodale bereikbaarheid”) : geef extra aandacht aan de ontsluiting met collectief vervoer en per fiets.
					<Tooltip
							text={MULTIMODALE_ONTSLUITING_TOOLTIP}
							tooltipType={types.TOOLTIP_INFO}
							windowWidth={40} />
					</FieldsetSubHeader>
					<TextAreaInput
						name="multimodaleOntsluiting"
						label="Multimodale ontsluiting"
						value={beoordelingscriteria.multimodaleOntsluiting}
						onChange={onChange}
						height={4}
						disabled={disabled}
						validationMessage={errors ? errors.multimodaleOntsluiting : ''}
						validationMessageType={validationMessageType}
						maxLength={4000} />
				</Row>
			</Row>
		</Fieldset>
	);
};

// ----------------------------------------------------------------------------
IntegraleToegankelijkheidForm.propTypes = {
	beoordelingscriteria: PropTypes.object.isRequired,
	disabled: PropTypes.bool,
	errors: PropTypes.object,
	color: PropTypes.string.isRequired,
	onChange: PropTypes.func.isRequired,
	onCheckboxChange: PropTypes.func.isRequired,
	documenten: PropTypes.array,
	onDropFiles: PropTypes.func.isRequired,
	onDeleteFile: PropTypes.func.isRequired,
	fileTypes: PropTypes.object.isRequired,
	fileSessionStarted: PropTypes.bool,
	validationMessageType: PropTypes.string
};

export default IntegraleToegankelijkheidForm;
